export default [
  {
    path: 'qqtguideManage',
    name: {list:['全球商通中心','用户指南','指南管理','管理指南'],"portalType":"nfstzxguide"},
    component: () => import('@/views/article/articleManage.vue')
  },
  {
    path: 'qqtguideAdd',
    name: {list:['全球商通中心','用户指南','指南管理','添加指南'],"portalType":"nfstzxguide"},
    component: () => import('@/views/article/articleAdd.vue')
  },
  {
    path: 'qqtguideClassifi',
    name: {list:['全球商通中心','用户指南','指南管理','指南分类'],"portalType":"nfstzxguide"},
    component: () => import('@/views/article/articleClassifi.vue')
  },
  {
    path: 'qqtguideExamM',
    name: {list:['全球商通中心','用户指南','指南审核','指南审核'],"portalType":"nfstzxguide"},
    component: () => import('@/views/article/articleExamM.vue')
  },
  {
    path: 'qqtguidePz',
    name: {list:['全球商通中心','用户指南','指南审核','指南配置'],"portalType":"nfstzxguide"},
    component: () => import('@/views/article/articlePz.vue')
  },
  
  {
    path: 'qqtguideExam',
    name: {list:['全球商通中心','用户指南','指南审核','指南审核'],"portalType":"nfstzxguide",title:'文章审核'},
    component: () => import('@/views/article/articleExam.vue')
  },
]